import React, { ReactNode } from "react";
import { ITouchEvent, View } from "@tarojs/components";
import classNames from "classnames";
import "./index.scss";
import { XHComponentCommonProps } from "../../types";

export type AmountInputProps = {
  space?: number;
  value: string;
  maxlength: number;
  onFocus?: (e) => void;
  unit?: string;
  slot?: ReactNode;
  shortcut?: ReactNode;
  errTip?: string;
  maxAmount?: number | string;
  minAmount?: number | string;
  showUpgrade?: boolean;
  onUpgrade?: () => void;
  loanOnekey?: () => void;
  placeholder?: string;
  focus?: boolean;
  /** 借款步长 */
  step?: number;
  showBottom?: boolean;
  title?: ReactNode;
  dataTrackId?: string;
} & XHComponentCommonProps;

const AmountInput: React.FC<AmountInputProps> = props => {
  const {
    value,
    maxlength = value.length,
    onFocus,
    className,
    focus = false,
    shortcut = "借全部",
    step = 100,
    errTip = "",
    onUpgrade,
    minAmount,
    maxAmount,
    showUpgrade = false,
    loanOnekey = () => {},
    placeholder = `单笔${minAmount}-${maxAmount}元，${step}的整数倍`,
    slot,
    showBottom = true,
    title = false,
    dataTrackId,
  } = props;

  function renderInputs(): ReactNode {
    const Inputs: any = [""];

    if (value === "")
      return (
        <View className="xh-amount-input-top-amount-num-placeholder">
          {placeholder}
        </View>
      );
    for (let i = 0; i < maxlength; i++) {
      const char = value[i];
      Inputs.push(
        <View key={i} className="xh-amount-input-top-amount-num-key">
          {char}
        </View>
      );
    }
    return Inputs;
  }

  function handlerClick(e: ITouchEvent): void {
    e.stopPropagation();
    onFocus && onFocus(e);
  }
  const cls = classNames("xh-amount-input", className);

  const handleUpgrade = (e: ITouchEvent) => {
    e.stopPropagation();
    onUpgrade?.();
  };

  return (
    <View className={cls}>
      {title && <View className="xh-amount-input-title">{title}</View>}
      <View className="xh-amount-input-top">
        <View className="xh-amount-input-top-unit">&yen;</View>
        <View
          className="xh-amount-input-top-amount"
          onClick={handlerClick} // @ts-ignore
          dataTrackId={`${dataTrackId}_amount`}
        >
          <View className="xh-amount-input-top-amount-num">
            <View className="xh-amount-input-top-amount-num-key">&nbsp;</View>
            {renderInputs()}
            <View
              className={classNames("xh-amount-input-top-amount-num-cursor", {
                focus,
              })}
            ></View>
          </View>
          <View
            className="xh-amount-input-top-amount-shortcut"
            onClick={loanOnekey}
            // @ts-ignore
            dataTrackId={`${dataTrackId}_top_shortcut`}
          >
            {typeof shortcut === "string" ? (
              <View className="xh-amount-input-top-amount-shortcut-text">
                {shortcut}
              </View>
            ) : (
              shortcut
            )}
          </View>
        </View>
        {errTip && <View className="xh-amount-input-top-error">{errTip}</View>}
      </View>
      {slot && <View className="xh-amount-input-slot">{slot}</View>}
      {showBottom && (
        <View className="xh-amount-input-bottom">
          <View className="xh-amount-input-bottom-range">
            单笔可借：
            <View className="xh-amount-input-bottom-range-number">
              {minAmount}-{maxAmount}元
            </View>
          </View>
          {showUpgrade && (
            <View className="xh-amount-input-bottom-tip">
              <React.Fragment>
                <View
                  className="xh-amount-input-bottom-tip-update"
                  // @ts-ignore
                  dataTrackId={`${dataTrackId}_bottom`}
                  onClick={handleUpgrade}
                >
                  额度不够？
                </View>
              </React.Fragment>
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default AmountInput;
